import ClassicQuizParticipationQuestionModel from "./ClassicQuizParticipationQuestionModel";

export default class ClassicQuizParticipationModel {
  public classicQuizId: string = null;
  public userId: string = null;
  public questions: ClassicQuizParticipationQuestionModel[] = [];
  public correctOptions: number = null;
}
